import * as React from "react";
import styled  from "styled-components";

import {
    Grid,
    Hidden,
    Menu,
    MenuItem,
    AppBar as MuiAppBar,
    IconButton as MuiIconButton,
    Toolbar, Typography, useMediaQuery, Box
} from "@material-ui/core";

import { Menu as MenuIcon } from "@material-ui/icons";

import {
    Power, Sliders as SlidersIcon
} from "react-feather";
import { useStores } from "../../hooks";
import { observer } from "mobx-react";
import {Button, Paper} from "./libs";
import {Trans, useTranslation} from "react-i18next";
import {useHistory} from 'react-router';
import {useContext, useEffect, useState} from 'react';
import DocumentsStoreContext from '../../modules/documents/context';


const AppBar = styled(MuiAppBar)`
  background: ${props => props.theme.header.background};
  color: ${props => props.theme.header.color};
  box-shadow: ${props => props.theme.shadows[1]};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

/*const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${props => props.theme.header.indicator.background};
    color: ${props => props.theme.palette.common.white};
  }
`;*/


const UserMenu = (props: {
    logout: () => {}
}) => {
    const [anchorMenu, setAnchorMenu] = React.useState<any>(null);

    const toggleMenu = (event: React.SyntheticEvent) => {
        setAnchorMenu(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorMenu(null);
    };

    const {t} = useTranslation(["general"]);

    return (
        <>
            <IconButton
                aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
                aria-haspopup="true"
                onClick={toggleMenu}
                color="inherit"
            >
                <Power/>
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorMenu}
                open={Boolean(anchorMenu)}
                onClose={closeMenu}
            >
                <MenuItem onClick={closeMenu}>
                    {t('general:profile')}
                </MenuItem>
                <MenuItem onClick={props.logout}>
                    {t('general:signOut')}
                </MenuItem>
            </Menu>
        </>
    );
}

const MobileButtonsMenu = observer(() => {
    const {generalStore} = useStores();

    if(!generalStore.headerButton) return null;

    return (
        <Paper p={5}>
            {generalStore.headerButton}
        </Paper>
    );
})


const TariffButton = observer(() => {
    const documentsStore = useContext(DocumentsStoreContext);
    const { isOrganizationBranchLoaded, organizationBranch } = documentsStore;
    const { authStore } = useStores()
    const [status, setStatus] = useState<'expired' | 'overdue' | 'active'>('active')
    const history = useHistory()

    useEffect(() => {
        documentsStore.getOrganisationBranch();
    }, [documentsStore]);

    useEffect(() => {
        if (!isOrganizationBranchLoaded) return

        const tariffDetails = organizationBranch.activeTariffDetails
        const now = new Date()
        const menusActiveTillDate = tariffDetails.menusActiveTillDate
        const nextPaymentDate = tariffDetails.nextPaymentDate

        const isActive = now <= nextPaymentDate
        const isExpired = now > menusActiveTillDate

        if (isActive) {
            setStatus('active')
        } else if (isExpired) {
            setStatus('expired')
        } else {
            setStatus('overdue')
        }
    }, [isOrganizationBranchLoaded])

    const buttonStyles = {
        active: {
            color: '#2d81e0',
            backgroundColor: 'rgba(96,149,236,0.12)'
        },
        overdue: {
            color: '#724800',
            backgroundColor: 'rgba(255,206,116,0.3)'
        },
        expired: {
            color: '#ee412b',
            backgroundColor: 'rgba(221,71,59,0.12)'
        }
    }

    const buttonTexts = {
        active: authStore.isPaymentSoon() ? `До оплаты ${authStore.menusAliveStr()}` : "Тариф оплачен",
        overdue: `Меню активны ещё ${authStore.menusAliveStr()}`,
        expired: "Тариф истёк"
    }

    return isOrganizationBranchLoaded ? (
        <Button variant="contained"
                color="default"
                style={{
                    borderRadius: 20,
                    fontWeight: 400,
                    ...buttonStyles[status]
                }}
                onClick={() => history.push("/documents/tariff")}
        >
            <Typography variant="body2">
                {buttonTexts[status]}
            </Typography>
        </Button>
    ) : <></>
})

interface OwnProps {
    onDrawerToggle: React.MouseEventHandler<HTMLElement>;
}

const Header: React.FC<OwnProps> = ({ onDrawerToggle }) => {
    const {generalStore, authStore} = useStores();

    return <>
        <AppBar position="sticky" elevation={0}>
            <Toolbar>
                <Grid container alignItems="center">
                    <Hidden lgUp>
                        <Grid item>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={onDrawerToggle}
                            >
                                <MenuIcon/>
                            </IconButton>
                        </Grid>
                    </Hidden>
                    <Grid item>
                        <div style={{ color: "#000", marginLeft: 10, display: "flex" }}>
                            <Typography variant="h4" display="block">
                                {generalStore.pageTitle}
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs/>
                    <Hidden mdUp>
                        <TariffButton/>
                    </Hidden>
                    <Hidden smDown>
                        <Grid item>
                            {generalStore.headerButton}
                            <div style={{ minWidth: 20, display: "inline-block" }}/>
                            {/*<IconButton color="inherit">
                            <Indicator badgeContent={3}>
                                <MessageSquare />
                              </Indicator>
                            </IconButton>

                           {/* <IconButton color="inherit">
                                <Indicator badgeContent={7}>
                                    <Bell/>
                                </Indicator>
                            </IconButton>*/}
                            {/*<LanguageMenu />*/}
                            <TariffButton/>
                            <span
                                style={{ display: "inline-block", minWidth: 20 }}
                            />
                            <UserMenu logout={() => authStore.logout()}/>
                        </Grid>
                    </Hidden>
                </Grid>
            </Toolbar>
        </AppBar>
        <Hidden mdUp>
            <MobileButtonsMenu/>
        </Hidden>
    </>
};

export default observer(Header);
